<template>
    <div>
      <el-checkbox
        v-if="permission.level != 1"
        :indeterminate="permission.isIndeterminate"
        v-model="permission.checkAll"
        @change="handleCheckAllChange"
      >{{ permission.name }}</el-checkbox>
  
      <div v-if="permission.children && permission.children.length > 0" style="margin-left: 20px;">
        <permission-item
          v-for="child in permission.children"
          :key="child.id"
          :permission="child"
          @update:select="handleSelect"
        ></permission-item>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'PermissionItem',
    props: {
      permission: Object,
    },
    methods: {
      handleCheckAllChange(value) {
        this.updateChildrenCheckState(this.permission, value);
        this.updateParentCheckState(this.permission);
      },
      handleSelect(data) {
        this.updateParentCheckState(data.permission);
      },
      updateChildrenCheckState(permission, value) {
        if (permission.children) {
          permission.children.forEach(child => {
            this.$set(child, 'checkAll', value);
            this.updateChildrenCheckState(child, value);
          });
        }
      },
      updateParentCheckState(permission) {
        if (permission && permission.parent) {
          let parent = permission.parent;
          let totalChildren = Array.isArray(parent.children) ? parent.children.length : 0;
          let checkedChildren = Array.isArray(parent.children) ? parent.children.filter(child => child.checkAll).length : 0;
          let checkedIndeterminate = Array.isArray(parent.children) ? parent.children.filter(child => child.isIndeterminate).length : 0;
          this.$set(parent, 'isIndeterminate', (checkedChildren > 0 && checkedChildren < totalChildren) || checkedIndeterminate > 0);
          if(checkedChildren === totalChildren){
            this.$set(parent, 'checkAll', true);
          }
          if(checkedChildren === 0 && checkedIndeterminate === 0){
            this.$set(parent, 'checkAll', false);
          }
          
          this.updateParentCheckState(parent);
        }
      }
    },
    watch: {
      'permission.checkAll': function(value) {
        this.updateChildrenCheckState(this.permission, value);
        this.updateParentCheckState(this.permission);
      },
      'permission.children': {
        handler() {
          this.updateParentCheckState(this.permission);
        },
        deep: true
      }
    }
  }
  </script>
  